module.exports = __webpack_public_path__ + "img/Morgan-TOPS.0aa605af.jpg";